import { Link } from 'react-router-dom';
import { Swiper } from 'swiper/react';
import { styled, Theme } from '@mui/material';

export const sxStyles = {
  paginationButton: (theme: Theme) => ({
    marginLeft: '0.625rem',
    minWidth: '48px',
    minHeight: '48px',

    '& > svg:first-of-type': {
      fill: theme.palette.common.white,
    },
  }),
  sliderTitle: (theme: Theme) => ({
    minHeight: '40px',
    color: theme.palette.primary.main,
  }),
};

export const StyledSwiper = styled(Swiper)(({ theme }) => ({
  overflow: 'visible',
  position: 'relative',

  '.swiper-pagination-bullet': {
    background: theme.palette.common.white,
    width: '12px',
    height: '12px',
    border: `1px solid ${theme.palette.primary.dark}`,
    opacity: '1',
  },

  '.swiper-pagination-bullets': {
    bottom: '-7px !important',
  },

  '.swiper-pagination-bullet-active': {
    background: theme.palette.primary.dark,
  },

  '.swiper-slide': {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '4rem',

    '& > div:first-of-type': {
      boxSizing: 'border-box',
    },

    [theme.breakpoints.up('md')]: {
      justifyContent: 'start',
    },
  },
}));

export const StyledNavigationButtonsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  maxHeight: '48px',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  visibility: 'hidden',

  [theme.breakpoints.up('md')]: {
    overflow: 'visible',
    visibility: 'visible',
    width: 'auto',
    height: 'auto',
  },
}));

export const StyledNavigationLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '210px',
  maxHeight: '48px',
  fontSize: '1rem',
  fontWeight: 600,
  padding: '0.75rem 2rem',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '4px',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '#EBF6F7',
  },
}));

export const StyledSliderInner = styled('div')(() => ({
  maxWidth: '940px',
  minHeight: '584px',
  margin: '0 auto',
  width: '100%',
  paddingTop: '4rem',
  overflowX: 'hidden',
}));

export const StyledSliderHeader = styled('div', { shouldForwardProp: (prop) => prop !== 'data-testid' })(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gridColumnGap: '2rem',
  alignItems: 'center',
  marginBottom: '2.25rem',
}));
